module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABABAMAAAAe8c9HAAAAFVBMVEX///9DfrkAAAAcOVVIkdllZWX///+AHV2mAAAAAnRSTlPQ/TSnhoYAAAA2SURBVHjaYxRkIBUwuoxqGdUyqmVEajEmXYvSqJZRLaNaRqSWUNK1pI1qGdUyqmVEaiFZBwMAtgMQyqLdducAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ee.png
// module id = rZpI
// module chunks = 0